import React from 'react';
import { Box, Typography } from '@mui/material';
import { gray80, white } from '../../../constants/colors';
import MetaTitle from '../../utils/MetaTitle';
import logoImage from '../../assets/logo_color.png';

const DEFAULT_MESSAGE =
  'ただいまメンテナンスを実施しております。\nしばらくしてから、再度アクセスしてください。';

const styles = {
  // 白背景に、公式カラーロゴ（オレンジのマーク＋紺色の「Gen Drive」）を中央配置する。
  container: {
    alignItems: 'center',
    backgroundColor: white,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: '100vh',
    px: '24px',
    py: '48px',
    width: '100%',
  },
  content: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '560px',
    textAlign: 'center',
    width: '100%',
  },
  // 公式カラーロゴ（白背景・オレンジマーク＋紺ロゴタイプ）。白背景に馴染む。
  logo: {
    height: 'auto',
    width: '300px',
    '@media screen and (max-width:600px)': {
      width: '240px',
    },
  },
  message: {
    color: gray80,
    fontSize: '18px',
    fontWeight: '400',
    lineHeight: 1.8,
    mt: '40px',
    whiteSpace: 'pre-wrap',
    '@media screen and (max-width:600px)': {
      fontSize: '16px',
      mt: '32px',
    },
  },
};

type Props = {
  message?: string;
};

const Maintenance = ({ message }: Props): JSX.Element => {
  return (
    <>
      <MetaTitle customTitle="メンテナンス中" />
      <Box sx={styles.container}>
        <Box sx={styles.content}>
          <Box component="img" src={logoImage} alt="Gen Drive" sx={styles.logo} />
          <Typography component="h1" sx={styles.message}>
            {message?.trim() ? message : DEFAULT_MESSAGE}
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default Maintenance;
